import React from 'react';

/**
 * Animated Cosmic Marvel × Liquid Holographic background.
 * Pure CSS layers (see styles/cosmic.css).
 */
const CosmicBackground = () => {
  return (
    <div className="cosmic-bg" aria-hidden="true">
      <div className="cosmic-gradient" />
      <div className="cosmic-stars" />
      <div className="cosmic-stars2" />
      <div className="cosmic-orb orb-1" />
      <div className="cosmic-orb orb-2" />
      <div className="cosmic-orb orb-3" />
      <div className="cosmic-grid" />
    </div>
  );
};

export default CosmicBackground;
